import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Suspense } from 'react';
import routes from './data/routes';
import { AuthProvider } from './context/AuthContext';
import { FavoritesProvider } from './context/FavoritesContext';
import Alert from './ui/atom/Alert';
import SvgIcn from './data/IconCompo';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router>
    <AuthProvider>
      <FavoritesProvider>
        <Suspense fallback={
          <Alert 
            message="Loading..." 
            type="loading" 
            isVisible={true}
          />
        }>
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>
        </Suspense>
      </FavoritesProvider>
    </AuthProvider>
  </Router>
);


